import { useEffect, useState } from 'react';
import { DialogUI } from '../Interface';
import Comments from './Comments';
import commentService from '../../service/comment.service';
import { Box } from '@mui/material';

const CommentDialog = ({ dialogData, handleClose, setRefetchTable }) => {
  const { open, lineId, subMenuUrl } = dialogData;
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (!open) {
      setRows([]);
    }
  }, [open]);

  useEffect(() => {
    if (lineId && subMenuUrl) {
      getData();
    }
  }, [lineId, subMenuUrl]);

  const getData = () => {
    commentService.getItems(subMenuUrl, lineId).then((data) => {
      setRows(data);
    });
  };

  return (
    <DialogUI
      open={open}
      headerContent="Hozzászólások"
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '600px',
            mx: 1,
          },
        },
        '& .MuiDialogContent-root': {
          px: 1,
        },
      }}
      onClose={handleClose}
      closeBtn={true}
    >
      <Box mt="1rem">
        <Comments rows={rows} lineId={lineId} subMenuUrl={subMenuUrl} setRefetchTable={setRefetchTable} />
      </Box>
    </DialogUI>
  );
};

export default CommentDialog;
